export const GOOGLE_MAPS_CONFIG = {
  googleMapsApiKey: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY as string,
  libraries: ['places'] as ('places' | 'drawing' | 'geometry' | 'visualization')[],
};

export const MAP_OPTIONS = {
  streetViewControl: false,
  mapTypeControl: false,
  fullscreenControl: false,
  clickableIcons: false,
  disableDefaultUI: true,
  disableDoubleClickZoom: true,
  gestureHandling: 'none',
  keyboardShortcuts: false,
  styles: [{ elementType: 'labels', featureType: 'poi', stylers: [{ visibility: 'off' }] }],
};
